import React from 'react';
import { useParams } from 'react-router-dom';
import EmpresasPanel from '../../components/Organizaciones/EmpresasPanel/EmpresasPanel';
import SucursalesPanel from '../../components/Organizaciones/SucursalesPanel/SucursalesPanel';
import '../Configuraciones/Configuraciones.css';

const normalizeText = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export default function Organizaciones() {
  const { seccion } = useParams();
  const normalized = normalizeText(seccion);
  
  const isEmpresas = normalized === 'empresas' || normalized === 'empresa';
  const title = isEmpresas ? 'Empresas' : 'Sucursales';
  const subtitle = isEmpresas
    ? 'Información de empresa asociada al usuario.'
    : 'Listado de sucursales de la empresa.';

  return (
    <section className="config-page">
      <header className="config-page-header">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </header>
      
      {isEmpresas ? <EmpresasPanel /> : <SucursalesPanel />}
    </section>
  );
}
